import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {take, map} from 'rxjs/operators';
import {SettingsService} from '../core/settings.service';
import {Cookie} from '../helper/cookie';
import {User} from './user.model';
import * as fromUser from './store/user.reducers';

@Injectable()
export class UserService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private cookie: Cookie,
    private store: Store<fromUser.State>

  ) {}

  getUser() {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'users/' + this.cookie.getCookie('auditor-user-id'),
      {
        params: {

        }
      }
      );
  }

  getUserByUid() {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'users/' + this.cookie.getCookie('auditor-uid') + '/by/uid',
      {
        params: {

        }
      }
    );
  }

  changeUser(id: number, params: any) {
    params['id'] = id;

    return this.httpClient.put(
      this.settingsService.getSetting('apiHost') + 'users',
      params
    );
  }

  changeUserPassword(id: number, password: string, retypedPassword: string) {
    return this.httpClient.put(
      this.settingsService.getSetting('apiHost') + 'users/password',
      {
        id: id.toString(),
        password: password,
        retyped_password: retypedPassword
      }
    );
  }

  registerUserTrial(id: number, username: string, password: string, retypedPassword: string) {
    return this.httpClient.put(
      this.settingsService.getSetting('apiHost') + 'users/register/trial',
      {
        id: id.toString(),
        username: username,
        password: password,
        retyped_password: retypedPassword
      }
    );
  }

  isAdmin(): Observable<boolean> {
    return this.store.select('user').pipe(
      take(1),
      map(
        (state: any) => {
          if (state.user !== null && state.user.roles.indexOf(User.ROLE_ADMIN) >= 0) {
              return true;
          }
          return false;
        }
      )
    );
  }

}
